import { makeStyles } from "@material-ui/core";
import styled from "styled-components";

export const ContentMyGames = styled.div`
  width: 96.5%;
  margin-left: 1em;
  max-height: 50vh;
  overflow-y: auto;
`;

export const useStyles = makeStyles(() => ({
  containMySpaces: {
    margin: "0",
  },
  bodyMySpaces: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    padding: "0",
  },
  rowContainMySpaces: {
    width: "100%",
    flexDirection: "row !important",
  },
  colCardMySpaces: {
    width: "100%",
    height: "fit-content",
    cursor: "pointer",
    padding: "0",
    maxWidth: "48%",
  },
  rightCard: {
    marginLeft: "2%",
  },
}));
